import { useEffect } from 'react';
import refresh from 'api/auth/refreshToken';
import useAuth from 'auth/hook/useAuth';
import axios from 'axios';

const instance = axios.create({ withCredentials: true });

const useCredentials = () => {
  const { auth, setAuth } = useAuth();

  useEffect(() => {
    const requestIntercept = instance.interceptors.request.use(
      (config) => {
        // console.log('intercept');
        if (!config.headers?.['Authorization']) {
          config.headers = {
            ...config.headers,
            Authorization: `Bearer ${auth?.accessToken}`,
          };
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    const responseIntercept = instance.interceptors.response.use(
      (response) => response,
      async (error) => {
        const prevRequest = error?.config;
        if (error?.response?.status === 403 && !prevRequest?.sent) {
          prevRequest.sent = true;
          const newAuth = await refresh().catch((err) => {
            return Promise.reject(err);
          });
          setAuth(newAuth);
          prevRequest.headers[
            'Authorization'
          ] = `Bearer ${newAuth.accessToken}`;
          return instance(prevRequest);
        }
        return Promise.reject(error);
      }
    );

    return () => {
      instance.interceptors.request.eject(requestIntercept);
      instance.interceptors.response.eject(responseIntercept);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth?.accessToken]);

  return instance;
};

export default useCredentials;
